import { render, staticRenderFns } from "./MenuService.vue?vue&type=template&id=2d68b202&scoped=true&"
import script from "./MenuService.vue?vue&type=script&lang=js&"
export * from "./MenuService.vue?vue&type=script&lang=js&"
import style0 from "./MenuService.vue?vue&type=style&index=0&id=2d68b202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68b202",
  null
  
)

export default component.exports